<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="javascript:void(0)">Game Management</a>
    <div class="collapse navbar-collapse">
        <a class="btn btn-sm btn-outline-primary ms-auto" [routerLink]="['/lo', company_uuid, 'setting-game', 'form']">&#43; Add Game</a>
    </div>
  </div>
</nav>
<hr/>
<div class="row">
  <div class="col-12">
    <app-table #table></app-table>
  </div>
</div>

<div class="row mt-4">
  <div class="col-12">
    <div class="border rounded p-3">
      <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
        <div>
          <h6 class="mb-1">Overwrite Company Game Sales</h6>
          <div class="small text-muted">Move transaction_game sales from one company game to another. The logged-in admin is recorded in the audit log.</div>
        </div>
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="previewOverwrite()" [disabled]="is_previewing || is_overwriting">
          {{ is_previewing ? 'Previewing' : 'Preview' }}
        </button>
      </div>

      <div class="row g-2 align-items-end">
        <div class="col-12 col-md-3">
          <label class="form-label small">Source Game</label>
          <select class="form-select form-select-sm" [(ngModel)]="overwrite.from_game_uuid" (change)="overwrite_preview = null">
            <option value="">Select game</option>
            <option *ngFor="let game of games" [value]="game.uuid">{{game.title}}</option>
          </select>
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label small">Target Game</label>
          <select class="form-select form-select-sm" [(ngModel)]="overwrite.to_game_uuid" (change)="overwrite_preview = null">
            <option value="">Select game</option>
            <option *ngFor="let game of games" [value]="game.uuid">{{game.title}}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label small">Date From</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="overwrite.date_from" (change)="overwrite_preview = null" />
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label small">Date To</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="overwrite.date_to" (change)="overwrite_preview = null" />
        </div>
        <div class="col-12 col-md-2">
          <label class="form-label small">Options</label>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="includePlayerIds" [(ngModel)]="overwrite.include_player_ids" (change)="overwrite_preview = null">
            <label class="form-check-label small" for="includePlayerIds">Move player IDs</label>
          </div>
        </div>
        <div class="col-12">
          <label class="form-label small">Note</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="overwrite.note" placeholder="Reason or ticket reference" />
        </div>
      </div>

      <div class="mt-3 p-2 bg-light border rounded" *ngIf="overwrite_preview && overwrite_preview.status">
        <div class="row g-2 small">
          <div class="col-12 col-md-3"><strong>Rows:</strong> {{overwrite_preview.summary.rows_count}}</div>
          <div class="col-12 col-md-3"><strong>Debit:</strong> {{overwrite_preview.summary.total_debit | number:'1.2-2'}}</div>
          <div class="col-12 col-md-3"><strong>Credit:</strong> {{overwrite_preview.summary.total_credit | number:'1.2-2'}}</div>
          <div class="col-12 col-md-3"><strong>Player IDs:</strong> {{overwrite_preview.player_game_id_rows}}</div>
        </div>
        <div class="small text-muted mt-1" *ngIf="overwrite_preview.summary.first_timestamp">
          {{overwrite_preview.summary.first_timestamp | date:'yyyy-MM-dd HH:mm:ss'}} to {{overwrite_preview.summary.last_timestamp | date:'yyyy-MM-dd HH:mm:ss'}}
        </div>
        <button class="btn btn-sm btn-danger mt-2" type="button" (click)="applyOverwrite()" [disabled]="is_overwriting || overwrite_preview.summary.rows_count == 0">
          {{ is_overwriting ? 'Overwriting' : 'Apply Overwrite' }}
        </button>
      </div>
    </div>
  </div>
</div>
